import { render } from "./SmActions.vue?vue&type=template&id=6bb6bed8"
import script from "./SmActions.vue?vue&type=script&lang=js"
export * from "./SmActions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__